import React from "react";
import "./Footer.css";
//import { Button } from "./Button";
import ContactForm from "./ContactForm";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <div className="footer-container" id="contact-us">
      <section className="footer-subscription">
        <p className="footer-subscription-heading">Contact Us</p>
        <p className="footer-subscription-text">Email or call us.</p>
        <p>bcer@primechfa.com</p>
        <p>lltee@primechfa.com</p>
        <br></br>
        <p className="footer-subscription-text">
          010-220 0295 <br />
          012-377 9288 
        </p>

        {/* <p className="footer-subscription-text">Fax: 03-8011 3055</p> */}

        <ContactForm></ContactForm>

        <p className="about-us">
          Primech Industrial Supplies (M) Sdn Bhd is a Automation Solution
          Provider & specialized in Belt Conveyor, Roller Conveyor, Chain
          Conveyor, Curve Conveyor, customized design system & related conveyor
          components.
        </p>
        <br></br>
        <p className="about-us">
          Our company is dedicated to design, fabrication, installation, testing
          & commissioning of conveyor systems for all of range of industries by
          according to requirements of customers.
        </p>
        <br></br>
        <p className="about-us">
          Our mission is to seeking constant customer satisfaction by cist
          effective, high quality, reliable solutions, on-time delivery &
          professional services. Our Vision is to be one of leading in
          automation & conveyor system & growth by globally.
        </p>
        {/* <div className="input-areas">
          <form>
            <input
              className="footer-input"
              name="email"
              type="email"
              placeholder="Your Email"
            />
            <Button buttonStyle="btn--outline">Subscribe</Button>
          </form>
        </div> */}
      </section>
      {/* 
      <div class="footer-links">
        <div className="footer-link-wrapper">
          <div class="footer-link-items">
            <h2>About Us</h2>
            <Link to="/sign-up">How it works</Link>
            <Link to="/">Testimonials</Link>
            <Link to="/">Careers</Link>
            <Link to="/">Investors</Link>
            <Link to="/">Terms of Service</Link>
          </div>
          <div class="footer-link-items">
            <h2>Contact Us</h2>
            <Link to="/">Contact</Link>
            <Link to="/">Support</Link>
            <Link to="/">Destinations</Link>
            <Link to="/">Sponsorships</Link>
          </div>
        </div>
        <div className="footer-link-wrapper">
          <div class="footer-link-items">
            <h2>Videos</h2>
            <Link to="/">Submit Video</Link>
            <Link to="/">Ambassadors</Link>
            <Link to="/">Agency</Link>
            <Link to="/">Influencer</Link>
          </div>
          <div class="footer-link-items">
            <h2>Social Media</h2>
            <Link to="/">Instagram</Link>
            <Link to="/">Facebook</Link>
            <Link to="/">Youtube</Link>
            <Link to="/">Twitter</Link>
          </div>
        </div>
      </div> */}
      <section className="social-media">
        <div className="social-media-wrap">
          <div className="footer-logo">
            <Link to="/" className="social-logo" id="company-logo">
              Primech
            </Link>
          </div>
          <small className="website-rights">
            PRIMECH © {new Date().getFullYear()} All rights reserved.
          </small>

          {/* <div ="social-icons">
            <Link
              class="social-icon-link facebook"
              to="/"
              target="_blank"
              aria-label="Facebook"
            >
              <i class="fab fa-facebook-f" />
            </Link>
            <Link
              class="social-icon-link instagram"
              to="/"
              target="_blank"
              aria-label="Instagram"
            >
              <i class="fab fa-instagram" />
            </Link>
            <Link
              class="social-icon-link youtube"
              to="/"
              target="_blank"
              aria-label="Youtube"
            >
              <i class="fab fa-youtube" />
            </Link>
            <Link
              class="social-icon-link twitter"
              to="/"
              target="_blank"
              aria-label="Twitter"
            >
              <i class="fab fa-twitter" />
            </Link>
            <Link
              class="social-icon-link twitter"
              to="/"
              target="_blank"
              aria-label="LinkedIn"
            >
              <i class="fab fa-linkedin" />
            </Link>
          </div> */}
        </div>
      </section>
    </div>
  );
}

export default Footer;
